import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '@anecdotes/auth-core';
import { MenuAction } from '@anecdotes/design-system/dropdown-menu';
import { CommentingFacadeService, ConfirmationModalService } from '../../services';
import { BaseThreadComponent } from '../base-thread/base-thread.component';

@Component({
  selector: 'app-resolved-thread',
  templateUrl: './resolved-thread.component.html',
  styleUrls: ['./../base-thread/base-thread.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResolvedThreadComponent extends BaseThreadComponent {
  menuActions: MenuAction[] = [
    {
      id: 'set-active',
      translationKey: 'commenting.options.setActive',
      action: () => this.setActive(),
    },
    {
      id: 'delete-thread',
      translationKey: 'commenting.options.delete',
      action: () => this.deleteThread(),
    },
  ];

  constructor(
    protected commentingFacadeService: CommentingFacadeService,
    protected authService: AuthService,
    protected modalWindowService: ConfirmationModalService
  ) {
    super(commentingFacadeService, authService, modalWindowService);
  }

  private setActive(): void {
    this.commentingFacadeService.activateThreadAsync(this.resource.threadId);
  }
}
